import { defineMessages } from 'react-intl';

/** The copy of the Studio showcase (design music24-studio-showcase c1 to c5). */
export const showcaseMessages = defineMessages({
  // The top bar (c1, c5)
  demoChip: { id: 'app.sml.musicVideo.showcase.demoChip', defaultMessage: 'Demo' },
  homeLink: { id: 'app.sml.musicVideo.showcase.homeLink', defaultMessage: 'music24.com' },
  songTitle: { id: 'app.sml.musicVideo.showcase.songTitle', defaultMessage: '{artist} — {title}' },
  songLine: { id: 'app.sml.musicVideo.showcase.songLine', defaultMessage: 'music video · {length} · {size}' },
  phoneSongLine: { id: 'app.sml.musicVideo.showcase.phoneSongLine', defaultMessage: '{artist} · not saved' },
  kept: { id: 'app.sml.musicVideo.showcase.kept', defaultMessage: 'Changes stay in this tab' },
  signUpFree: { id: 'app.sml.musicVideo.showcase.signUpFree', defaultMessage: 'Sign up free' },
  make: { id: 'app.sml.musicVideo.showcase.make', defaultMessage: 'Make the video' },
  inspectorHint: {
    id: 'app.sml.musicVideo.showcase.inspectorHint',
    defaultMessage:
      'Every edit here works and plays at once. Nothing is saved: a reload starts again from the director’s cut.',
  },

  // The sign-up card (c2)
  cardLabel: { id: 'app.sml.musicVideo.showcase.card.label', defaultMessage: 'Sign up to MUSIC24' },
  cardTitle: { id: 'app.sml.musicVideo.showcase.card.title', defaultMessage: 'Sign up to MUSIC24 to make your own' },
  tickSong: {
    id: 'app.sml.musicVideo.showcase.card.tickSong',
    defaultMessage: 'Your song cut to the beat, with your lyrics on the voice',
  },
  tickFootage: {
    id: 'app.sml.musicVideo.showcase.card.tickFootage',
    defaultMessage: 'Your own footage and AI clips next to the bank',
  },
  tickFile: {
    id: 'app.sml.musicVideo.showcase.card.tickFile',
    defaultMessage: 'The full-song video file on Pro: {cost} credits of your {credits} a month',
  },
  keepPlaying: { id: 'app.sml.musicVideo.showcase.card.keepPlaying', defaultMessage: 'Keep playing' },
  startFree: { id: 'app.sml.musicVideo.showcase.card.startFree', defaultMessage: 'Start free' },
  fine: { id: 'app.sml.musicVideo.showcase.card.fine', defaultMessage: 'Free plan · no card' },

  // The c2 lines: a bold first sentence, then the rest
  makeLead: {
    id: 'app.sml.musicVideo.showcase.line.makeLead',
    defaultMessage: 'Make the video file of your own song.',
  },
  makeRest: {
    id: 'app.sml.musicVideo.showcase.line.makeRest',
    defaultMessage: 'Sign up free, add your master, and the director cuts it in about 30 seconds.',
  },
  recutLead: {
    id: 'app.sml.musicVideo.showcase.line.recutLead',
    defaultMessage: 'Ask the director for a new cut of your song.',
  },
  recutRest: {
    id: 'app.sml.musicVideo.showcase.line.recutRest',
    defaultMessage: 'Sign up free and recut any section as often as you want.',
  },
  aiLead: { id: 'app.sml.musicVideo.showcase.line.aiLead', defaultMessage: 'Make clips that only your song has.' },
  aiRest: {
    id: 'app.sml.musicVideo.showcase.line.aiRest',
    defaultMessage: 'An 8-second AI clip in the look of your song, for {credits} credits. Sign up to make them.',
  },
  footageLead: {
    id: 'app.sml.musicVideo.showcase.line.footageLead',
    defaultMessage: 'Put your own footage in the video.',
  },
  footageRest: {
    id: 'app.sml.musicVideo.showcase.line.footageRest',
    defaultMessage: 'Sign up free and add your phone clips, live shots and studio takes.',
  },
  cutsLead: {
    id: 'app.sml.musicVideo.showcase.line.cutsLead',
    defaultMessage: 'Keep more than one cut and compare them.',
  },
  cutsRest: {
    id: 'app.sml.musicVideo.showcase.line.cutsRest',
    defaultMessage: 'Sign up free. Every cut of your song is saved.',
  },

  // The locked tabs of the Footage panel (c3)
  lockedChip: { id: 'app.sml.musicVideo.showcase.locked.chip', defaultMessage: 'Sign up free' },
  locked: { id: 'app.sml.musicVideo.showcase.locked.label', defaultMessage: 'Needs an account' },
  backToBank: { id: 'app.sml.musicVideo.showcase.locked.backToBank', defaultMessage: 'Back to the bank' },
  yoursLine: {
    id: 'app.sml.musicVideo.showcase.locked.yoursLine',
    defaultMessage:
      'Your uploads and your AI clips live here. Sign up free and add your phone clips, live shots and studio takes.',
  },
  uploadLine: {
    id: 'app.sml.musicVideo.showcase.locked.uploadLine',
    defaultMessage: 'Sign up free and upload MP4 or MOV clips. They cut to the beat like the bank clips.',
  },
  aiHint: {
    id: 'app.sml.musicVideo.showcase.locked.aiHint',
    defaultMessage: 'AI clips are on every paid plan, from Plus at {price} a month.',
  },
  yoursHint: {
    id: 'app.sml.musicVideo.showcase.locked.yoursHint',
    defaultMessage: 'Yours is empty in the demo: you have no account here.',
  },
  uploadHint: {
    id: 'app.sml.musicVideo.showcase.locked.uploadHint',
    defaultMessage: 'A file dropped on the editor opens the same card.',
  },

  // The bank (c1, c4)
  inThisCut: { id: 'app.sml.musicVideo.showcase.bank.inThisCut', defaultMessage: 'In this cut' },
  inThisCutFacts: {
    id: 'app.sml.musicVideo.showcase.bank.inThisCutFacts',
    defaultMessage: '{count, plural, one {# bank clip} other {# bank clips}}',
  },
  all: { id: 'app.sml.musicVideo.showcase.bank.all', defaultMessage: 'All' },
  fewer: { id: 'app.sml.musicVideo.showcase.bank.fewer', defaultMessage: 'Fewer' },
  searchBusy: {
    id: 'app.sml.musicVideo.showcase.bank.searchBusy',
    defaultMessage: 'Search is busy. Try again in a minute.',
  },
});
